import { CommonLaboratoryResponse, EnumResponse } from '@/api/services/common.dto'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'

export enum BillableRateCopaymentType {
    PATIENT = 'PATIENT',
    CUSTOMER = 'CUSTOMER'
}

export interface BillableRateResponse {
    id: number
    name: string
    code: string
    laboratory: CommonLaboratoryResponse
    accountingUnit: AccountingUnitResponse
    startDate: string
    endDate: string
    isDefault: boolean
    allowsCopayment: boolean
    copaymentType: StrictNullable<EnumResponse>
}

export interface BillableRatePatchInBatchRequest {
    id: number
    name?: Nullable<string>
    code?: Nullable<string>
    startDate?: Nullable<string>
    endDate?: Nullable<string>
    isDefault?: Nullable<boolean>
    allowsCopayment?: Nullable<boolean>
    copaymentType?: Nullable<BillableRateCopaymentType>
}

export interface BillableRateCreateRequest {
    name: string
    code: string
    accountingUnitId: number
    startDate: string
    endDate: string
    isDefault: boolean
    allowsCopayment: boolean
    copaymentType?: Nullable<BillableRateCopaymentType>
}

export interface BillableRateCopyRequest {
    billableRateToBeCopiedId: number
    name: string
    code: string
    laboratoryId: number
    startDate: string
    endDate: string
    isCopyValues: boolean
    isDefault: boolean
    allowsCopayment: boolean
    accountingUnitId: number
}
